
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.688 2.889c.424 0 .84.115 1.202.333.361.218.653.53.843.9l.639 1.247c.047.093.12.17.21.225.09.055.195.084.3.084h4.832c.606 0 1.188.235 1.617.653.428.418.669.986.669 1.577v6.972c0 .592-.24 1.16-.67 1.578a2.314 2.314 0 01-1.616.653H4.286a2.314 2.314 0 01-1.617-.653A2.204 2.204 0 012 14.88V5.12c0-.592.24-1.16.67-1.578a2.314 2.314 0 011.616-.653h3.402zm.3 1.756a.582.582 0 00-.3-.083H4.286a.579.579 0 00-.404.163.551.551 0 00-.168.395v9.76c0 .148.06.29.168.394a.579.579 0 00.404.164h11.428a.578.578 0 00.404-.164.55.55 0 00.168-.394V7.908a.55.55 0 00-.168-.394.578.578 0 00-.404-.163h-4.831c-.425 0-.84-.116-1.202-.334a2.252 2.252 0 01-.843-.9L8.2 4.871a.564.564 0 00-.211-.226z"}})])
          )
        }
      }
    